<template>
  <div class="big">
    <el-page-header @back="goBack" content="历史通行记录"></el-page-header>
    <div class="cont">
      <div class="cont-t">
        <div class="cont-t-l">
          <div style="width: 1vw;height:1vw;margin-right:0.25vw;"></div>
          <div style="color: #666666;font-size: 0.8vw;">{{name}}-历史通行记录</div>
        </div>
        <div class="cont-t-r"><el-button style="background: #3871E5;" size="small" type="primary" @click="loadFile">导出</el-button></div>
      </div>
      <div class="cont-s">
        <el-input @change="getData" clearable v-model="personName" style="width:12.5vw;margin-right:.9375vw" size="small" placeholder="员工姓名" prefix-icon="el-icon-search"></el-input>
        <el-input @change="getData" clearable v-model="idNo" style="width:12.5vw;margin-right:.9375vw" size="small" placeholder="身份证号" prefix-icon="el-icon-search"></el-input>
        <el-date-picker
          size="small"
          :clearable="false"
          value-format="yyyy-MM-dd"
          v-model="date"
          @change="getData"
          type="date"
          placeholder="日期"
          style="width:12.5vw;margin-right:1.125vw">
        </el-date-picker>
        <el-select  @change="getData" clearable style="width:12.5vw;margin-right:1.125vw" size="small" v-model="flag" placeholder="状态">
          <el-option  label="正常" value="2"></el-option>
          <el-option  label="异常" value="1"></el-option>
        </el-select>
        <el-button style="background: #3871E5;" size="small" type="primary" @click="getData">搜索</el-button>
      </div>
      <div class="cont-c">
        <el-table  :data="tableList" height="59vh" border :header-cell-style="tableHeadStyle">
          <el-table-column
            label="序号"
            type="index"            
            width="50"                  
          >
              <template slot-scope="scope" >
              <div>{{ (pageNum-1)*pageSize+scope.$index+1}}</div>
            </template>
          </el-table-column>
          <el-table-column label="姓名" width="70">
            <template slot-scope="scope" >
              <div style="height:100%;cursor: pointer;width:100%;color:#0D3A95" @click="enter(scope.row)">{{ scope.row.name}}</div>
            </template>
          </el-table-column>
          <el-table-column label="身份证">
            <template slot-scope="scope" >
              <div>{{ scope.row.idNo}}</div>
            </template>
          </el-table-column>
          <el-table-column label="设备ID">
            <template slot-scope="scope" >
              <div>{{ scope.row.imei}}</div>
            </template>
          </el-table-column>
          <el-table-column label="通行体温" width="80">
            <template slot-scope="scope" >
              <div
                :style="scope.row.temperature>37.5?'color: #f00;':'color: #23D715;'"
              >{{ scope.row.temperature||0}}°c</div>
            </template>
          </el-table-column> 
          <el-table-column label="健康码">
            <template slot-scope="scope">
              <img :src="scope.row.codeImg" style="height: 6vh" />
            </template>
          </el-table-column> 
          <el-table-column label="核酸状态">
            <template slot-scope="scope">
              <div v-if="scope.row.signName == '阴性'">
                <img style="width: 2vw" src="../../assets/image/newAnKang/yin11.png">
                <p style="color: #23d715;">已过{{scope.row.timeSpan}}天</p>
              </div>
              <div v-else-if="scope.row.signName == '阳性'">
                <img style="width: 2vw" src="../../assets/image/newAnKang/yang.png">
                <p style="color: #E32932;">已过{{scope.row.timeSpan}}天</p>
              </div>
              <div v-else>
                <p style="color: #bebebe;">暂无核酸</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="途径地" width="70">
            <template slot-scope="scope" >
              <div>{{ scope.row.tripAddress||'无'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="行程状态" width="80">
            <template slot-scope="scope" >
              <div v-if="scope.row.tripStatus==0">无风险</div>
              <div v-else-if="scope.row.tripStatus==1">有风险</div>
              <div v-else>无</div>
            </template>
          </el-table-column>  
          <el-table-column label="通行照片">
            <template slot-scope="scope">
              <img
                v-if="scope.row.photoFile!=''"
                :src="scope.row.photoFile"
                style="width:70px;height:90px;"
              />
              <div
                v-else
                style="width:70px;height:90px;background: #ddd;display: flex;align-items: center;justify-content: center;"
              >暂无图片</div>
            </template>
          </el-table-column>
          <el-table-column label="通行时间">
            <template slot-scope="scope" >
              <div>{{ scope.row.date}}</div>
            </template>
          </el-table-column>      
          <el-table-column label="备注" width="160">
            <template slot-scope="scope">
              <div class="remarks">{{ scope.row.remarks}}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="70">
            <template slot-scope="scope">
              <div><el-button style="background: #3871E5;padding:7px 8px;" size="mini" type="primary" @click="openRm(scope.row)">编辑</el-button></div>
            </template>
          </el-table-column>                  
        </el-table>
        <el-dialog
          title="编辑"
          :close-on-click-modal="false"
          :visible.sync="dialogVisible"
          width="30%">
          <el-form label-width="65px">
            <el-form-item label="备注">
              
              <el-input
                type="textarea"
                :autosize="{ minRows: 8}"
                placeholder="请输入内容"
                maxlength="200"
                show-word-limit
                v-model="remarks">
              </el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="queRen">确 定</el-button>
          </span>
        </el-dialog>
        <el-pagination
        class="pagination-s"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[20, 100, 200, 300, 400]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
  export default {
    data() {
      return {
        id:'',
        remarks:'',
        dialogVisible:false,
        name:'',
        pageSize:20,
        pageNum:1,
        total:0,
        value: '',
        options: [],
        tableList:[],
        base:base.url,
        attendType:[],
        personName:'',
        status:'',
        idNo:'',
        date:'',
        flag:'',
        projectId:''
      }
    },
    mounted(){
      this.name = this.$route.query.name
      this.date = this.$route.query.date
      this.projectId = this.$route.query.projectId
      this.flag = this.$route.query.flag
      this.getDict()
    },
    methods:{
      queRen(){
        let that = this
        myHttp.updateAttendRemarksById({
          id:this.id,
          remarks:this.remarks,
          projectId:this.projectId
        }).then(res=>{
          if(res.data.code == 200){
            this.$message.success(res.data.msg)
            that.dialogVisible=false
            that.getData()
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },
      openRm(row){
        console.log('id',row)
        this.id=row.id
        this.remarks=row.remarks || ''
        this.dialogVisible = true
      },
      enter(row){
        let that =this
        console.log(row)
        this.$router.push({
          name:'visitorRecordListDataItem',
          params:{
            id:row.idNo,
            projectId:that.projectId
          }
        })
      },
      loadFile(){
        let token = util.session.get('token')
        window.open(
          myHttp.exportStrangerAttendList +
          '?accessToken=' +
          token +
          '&projectId=' +
          this.projectId +
          '&personName=' +
          this.personName +
          '&status=' +
          this.status +
          '&idNo=' +
          this.idNo +
          '&date=' +
          this.date
        )
      },
      logVal(){},
      getDict() {
        var that = this
        myHttp.getDictByType({
          type: 'attend_type'
        }).then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.dictList||[]
            for(var i=0;i<list.length;i++){
              list[i].text = list[i].label
            
            }
            that.attendType = list
            that.getData()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
      //获取类型
    filterSatus(str) {
      var list = this.attendType
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (str == list[i].value) {
          result = list[i].label
        }
      }
      return result
    },
      getData(){
        let that = this
        myHttp.findStrangerInOutPage({
          projectId:this.projectId,
          pageSize:this.pageSize,
          pageNum:this.pageNum,
          date:this.date,
          status:this.status,
          idNo:this.idNo,
          personName:this.personName,
          flag:this.flag
        }).then(res=>{
          console.log(res)
          if(res.data.code==200){
            let list = res.data.data.strangerInOutPage.list
            that.total = res.data.data.strangerInOutPage.total
            for (var i = 0; i < list.length; i++) {
              list[i].photoFile = list[i].photoFile && list[i].photoFile != '' ? base.httpCtx + list[i].photoFile : ''
              list[i].typeName = that.filterSatus(list[i].status)
              if (list[i].healthLevel == '1') {
                list[i].codeImg = require('../../assets/image/new/green.png')
              } else if (list[i].healthLevel == '2') {
                list[i].codeImg = require('../../assets/image/new/yellow.png')
              } else if (list[i].healthLevel == '3') {
                list[i].codeImg = require('../../assets/image/new/red.png')
              } else if (
                list[i].healthLevel == '4' ||
                list[i].healthLevel == '0'
              ) {
                list[i].codeImg = require('../../assets/image/new/no.png')
              }
              
              // list[i].idcardPhoto = list[i].idcardPhoto && list[i].idcardPhoto!=''?base.httpCtx+list[i].idcardPhoto:''
              // list[i].createDate = list[i].createDate && list[i].createDate!=''?list[i].createDate.split(' ')[0]:''
              // list[i].age = util.myTime.getAge(list[i].birthday)
            }
            this.tableList = list
          }
        })
      },
      handleSizeChange(val){
        this.pageSize=val
        this.pageNum=1
        this.getData()
      },
      handleCurrentChange(val){
        this.pageNum=val
        this.getData()
        
      },
      goBack(){
        this.$router.go(-1)
      },
      tableHeadStyle({ row, column, rowIndex, columnIndex }){
        if(rowIndex == 0){
          return `background-color: #EEE;`
        }
      },
    }
  }
</script>

<style scoped>
::v-deep .cell>div{
  font-size: .7292vw;
  text-align: start;
}
.pagination-s{
  box-shadow: 6px 0px 10px 0px rgba(197, 197, 197, 0.3);
}
.cont-c{
  padding: 0 .5208vw;

}
::v-deep .cell{
  font-size: .7292vw !important;
}
.big{
  width: 100%;
  height: 100%;
  padding: .5208vw 1.25vw .5208vw .8333vw;
  display: flex;
  flex-direction: column;
}
.cont{
  margin-top: .2604vw;
  flex: 1;
  box-shadow: 2px 2px 6px 0px rgba(77, 110, 177, 0.2);
  background: #FFFFFF;
  border-radius: .3125vw;
}
.cont-t{
  padding: .5208vw .6771vw
  ;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #E4E7EE;;
}
.cont-t-l{
  display: flex;
  align-items: center;
}
.cont-s{
  padding: .5208vw;
  display: flex;
  justify-content: start;
  align-items: center;
}
::v-deep .cell{
  font-size: .7292vw !important;
  text-align: start !important;
}
</style>